import React, { useState } from 'react';

import Button from './Button';

const QuickActionToolbar = ({ 
  className = '',
  actions = [],
  showRefresh = true,
  showExport = true,
  showFilter = true,
  onRefresh,
  onExport,
  onFilter
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (onRefresh) {
      setIsRefreshing(true);
      try {
        await onRefresh();
      } finally {
        setIsRefreshing(false);
      }
    }
  };

  const handleExport = async () => {
    if (onExport) {
      setIsExporting(true);
      try {
        await onExport();
      } finally {
        setIsExporting(false);
      }
    }
  };

  const defaultActions = [
    ...(showRefresh ? [{
      id: 'refresh',
      label: 'Refresh',
      icon: 'RefreshCw',
      onClick: handleRefresh,
      loading: isRefreshing,
      variant: 'ghost'
    }] : []),
    ...(showFilter ? [{
      id: 'filter',
      label: 'Filter',
      icon: 'Filter',
      onClick: onFilter,
      variant: 'ghost'
    }] : []),
    ...(showExport ? [{
      id: 'export',
      label: 'Export',
      icon: 'Download',
      onClick: handleExport,
      loading: isExporting,
      variant: 'outline'
    }] : [])
  ];

  const allActions = [...defaultActions, ...actions];

  if (allActions?.length === 0) {
    return null;
  }

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {allActions?.map((action) => (
        <Button
          key={action?.id}
          variant={action?.variant || 'ghost'}
          size={action?.size || 'sm'}
          onClick={action?.onClick}
          disabled={action?.disabled}
          loading={action?.loading}
          iconName={action?.icon}
          iconPosition="left"
          className={action?.className}
          title={action?.tooltip || action?.label}
        >
          {action?.showLabel !== false && action?.label}
        </Button>
      ))}
    </div>
  );
};

export default QuickActionToolbar;